module.exports = __webpack_public_path__ + "media/customizations/trilogy/logo-c41979a19c22ffa5b01f93549ebb053a.png";